import React from "react";
import { CCModeDataTable } from "./CCModeTable/CCModeDataTable";
import {
    Typography
  } from "@material-ui/core";
  import PropTypes from "prop-types";
  
  function TabContainer(props) {
    return (
        <Typography component="div" style={{ padding: 8 * 3 }}>
            {props.children}
        </Typography>
    );
  }
  
  TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
  };

export const CcmodeRule = (props) => {
    return (
        <>
        <div className="card shadow-none card-custom">
              <div className="bg-white">  
                <CCModeDataTable userinfo={props.userinfo} language={props.language} ccmoderules={props.ccmoderules} setUpdateRules={props.setUpdateRules} updaterule={props.updaterule} loader={props.loader}/>
              </div>
            </div>
        </>
    );
};
